import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-uikit/Typography";
import { EVENT_TYPES } from "./constants";

export const EventsTab = ({ activeTab, setActiveTab }: any) => {
  const tabs = [
    {
      name: t("events.upcoming"),
      active: activeTab === EVENT_TYPES.UPCOMING,
      onClick: () => setActiveTab(EVENT_TYPES.UPCOMING),
    },
    {
      name: t("events.past"),
      active: activeTab === EVENT_TYPES.PAST,
      onClick: () => setActiveTab(EVENT_TYPES.PAST),
    },
  ];

  return (
    <div className="mx-6 mb-8 grid grid-cols-2 py-1.5 pt-3 sm:flex sm:flex-row md:mx-0 md:max-w-2xl md:gap-2">
      {tabs.map(({ name, active, onClick }) => (
        <button
          key={name}
          type="button"
          className={classNames(
            "text-dark flex items-center justify-center rounded-md px-5 py-2.5",
            {
              "bg-overlay-dark": active,
            },
          )}
          onClick={onClick}
        >
          <Typography.LabelXs
            weight="medium"
            color={active ? "text-selector-active" : "text-default"}
          >
            {name}
          </Typography.LabelXs>
        </button>
      ))}
    </div>
  );
};
